import React from "react";
import useOnScreen from "../../../hooks/useOnScreen";

const valueBenefits = [
  {
    id: "value-1",
    icon: "📐",
    title: "Dari Basic ➤ IELTS Ready ",
    description: "20 lesson grammar fundamen + langsung masuk ke 4 skill IELTS. Gaada yang kelewat",
  },
  {
    id: "value-2",
    icon: "✍️",
    title: "AI Writing Feedback (Auto Band Score)",
    description: "Tulisanmu langsung dinilai dengan skor band, tahu persis di mana harus naik",
  },
  {
    id: "value-3",
    icon: "🔴",
    title: "Live Teaching + Rekaman Kelas",
    description: "Belajar bareng tutor alumni kampus luar negeri. Ga bisa hadir? Ada rekamannya!",
  },
  {
    id: "value-4",
    icon: "📊",
    title: "Simulasi Test + Evaluasi Skor",
    description: "Di akhir program ada simulasi IELTS lengkap + feedback detail per skill",
  },
];

const ValueBenefitsProduct2 = () => {
  const [ref, isVisible] = useOnScreen({ threshold: 0.2 });

  return (
    <section ref={ref} className="st-surface-value overflow-x-clip py-14 sm:py-16 lg:py-20" id="benefits">
      <div className="mx-auto w-full max-w-6xl px-6 sm:px-8 lg:px-12">
        <div className="text-center">
          <div className="st-value-badge inline-flex items-center rounded-full px-5 py-2 text-[11px] font-semibold uppercase tracking-[0.22em] shadow-[0_4px_12px_rgba(0,0,0,0.08)] sm:px-6 sm:text-[12px]">
            -- Program Benefits --
          </div>

          <h2 className="st-font-display st-value-heading mx-auto mt-8 max-w-5xl text-[42px] leading-[0.96] sm:text-[56px] lg:text-[72px]">
            <span className="block">
              Apa <span className="italic font-normal">yang Akan Kamu</span>
            </span>
            <span className="block font-semibold">Dapatkan?</span>
          </h2>

          <p className="st-font-body st-value-body mx-auto mt-5 max-w-4xl text-[18px] leading-[1.4] sm:text-[20px] lg:text-[22px]">
            Semua yang kamu butuhkan untuk tembus skor 6.5!
          </p>
        </div>

        <div className={`mt-10 space-y-4 sm:mt-12 ${isVisible ? "animate__animated animate__fadeInUp" : ""}`}>
          {valueBenefits.map((item) => (
            <article
              key={item.id}
              className="st-value-card grid gap-4 px-5 py-5 sm:grid-cols-[98px_1fr] sm:items-center sm:gap-6 sm:px-6 sm:py-6"
            >
              <div className="st-value-icon flex h-[78px] w-[78px] items-center justify-center text-[34px] leading-none sm:h-[90px] sm:w-[90px] sm:text-[40px]">
                <span aria-hidden="true">{item.icon}</span>
              </div>

              <div>
                <h3 className="st-font-body st-value-title text-[24px] font-semibold leading-[1.15] sm:text-[26px] lg:text-[28px]">
                  {item.title}
                </h3>
                <p className="st-font-body st-value-text mt-2 max-w-4xl text-[17px] leading-[1.45] sm:text-[18px] lg:text-[20px]">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueBenefitsProduct2;